import React from "react";
import Hero from "../components/Hero";
import TrustStrip from "../components/TrustStrip";
import HowItWorks from "../components/HowItWorks";
import FreelancersGrid from "../components/FreelancersGrid";
import WhyThisSite from "../components/WhyThisSite";
import ProjectForm from "../components/ProjectForm";
import About from "../components/About";
import FinalCTA from "../components/FinalCTA";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <TrustStrip />
      <HowItWorks />
      <FreelancersGrid />
      <WhyThisSite />
      <ProjectForm />
      <About />
      <FinalCTA />
    </div>
  );
}
